import type {PossibleTypes, UnionObjectTypesMap} from '../links/RestLink/types';

export default function getPossibleTypes(
  unionObjectTypesMap: UnionObjectTypesMap,
): PossibleTypes {
  const output: PossibleTypes = {};

  Object.entries(unionObjectTypesMap).forEach(([typename, paths]) => {
    output[typename] = Array.from(new Set(Object.values(paths).flat()));
  });

  return output;
}
